import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/courses/[id]/page.tsx");
